import { enqueueSnackbar, OptionsObject, SnackbarMessage } from 'notistack'

export const showToast = (text: SnackbarMessage, options: OptionsObject = {}) => {
  enqueueSnackbar(text, {
    autoHideDuration: 3000,
    ...options,
  })
}
